module.exports = __webpack_public_path__ + "static/media/ONE.b98b767d.svg";